import { ModelPromiseClient } from '@trustero/trustero-api-web/lib/model/model_grpc_web_pb'
import { Empty } from 'google-protobuf/google/protobuf/empty_pb'
import { Frameworks } from '@trustero/trustero-api-web/lib/model/framework_pb'
import { useSwrImmutableGrpc } from '../useSwrImmutableGrpc'
import { GrpcResponse, NewGrpcResponse } from '../hooks/types'

export const useFrameworks = (): GrpcResponse<Frameworks> => {
  const { response } = useSwrImmutableGrpc(
    ModelPromiseClient.prototype.listFrameworks,
    new Empty(),
  )
  return NewGrpcResponse(response)
}
